import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M21.808 13.95a10 10 0 0 0-.81-6.314q-.229.422-.584.778l-.884.884a8 8 0 0 1-1.873 8.359 1 1 0 1 0 1.414 1.414 10 10 0 0 0 2.737-5.12M16.364 3.002a10 10 0 0 0-11.435 16.07 1 1 0 0 0 1.414-1.415A8 8 0 0 1 14.702 4.47l.884-.884a3.4 3.4 0 0 1 .778-.584"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M14.868 11.117A1.4 1.4 0 0 0 15 11l4-4a1.414 1.414 0 1 0-2-2l-4 4a1.4 1.4 0 0 0-.117.132 3 3 0 1 0 1.985 1.985"
    }
  )
);
var SvgDialLowFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var DialLowFilled_default = SvgDialLowFilled;

export { DialLowFilled_default as default };
